/* eslint-disable jsx-a11y/heading-has-content */
import React, { useState } from "react";
import { PageBase } from "../../../Components/PageBase";
import "./Perfil.css"
import img from "../../../icons/calendar-sharp.svg";
import { useRol } from "../../../Context";

function Perfil() {
    const { dataProfile, rol } = useRol();
    const [valor, setValor] = useState(dataProfile.first_name);

    const handleInputChange = (e) => {
        setValor(e.target.value);
    };

    const [valor2, setValor2] = useState(dataProfile.last_name);

    const handleInputChange2 = (e) => {
        setValor2(e.target.value);
    };

    const [valor3, setValor3] = useState(dataProfile.username);

    const handleInputChange3 = (e) => {
        setValor3(e.target.value);
    };

    const [valor4, setValor4] = useState(dataProfile.email);

    const handleInputChange4 = (e) => {
        setValor4(e.target.value);
    };

    const [valor5, setValor5] = useState(rol);

    const handleInputChange5 = (e) => {
        setValor5(e.target.value);
    };

    function formatDateToLongDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString('es-ES', options);
    }

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="perfil-container">
                    <div className="perfil-porlet-card">
                        <div className="profile-info">
                            <h2>Configuración de perfil</h2>
                            <span>Ayudanos a conocer más acerca de ti completando tus datos de perfil.</span>
                            <hr />
                            <div className="perfil-form">
                                <div className="perfil-data">
                                    <div className="perfil-data-container">
                                        <label>Nombre:</label>
                                        <input
                                            type="text"
                                            value={valor}
                                            onChange={handleInputChange}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="perfil-data">
                                    <div className="perfil-data-container">
                                        <label>Apellido:</label>
                                        <input
                                            type="text"
                                            value={valor2}
                                            onChange={handleInputChange2}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="perfil-data">
                                    <div className="perfil-data-container">
                                        <label>Usuario:</label>
                                        <input
                                            type="text"
                                            value={valor3}
                                            onChange={handleInputChange3}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="perfil-data">
                                    <div className="perfil-data-container">
                                        <label>Correo:</label>
                                        <input
                                            type="text"
                                            value={valor4}
                                            onChange={handleInputChange4}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="perfil-data">
                                    <div className="perfil-data-container">
                                        <label>Rol:</label>
                                        <input
                                            type="text"
                                            value={valor5}
                                            onChange={handleInputChange5}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="perfil-data">
                                    <div className="perfil-data-container">
                                        <button>Editar perfil</button>
                                    </div>
                                </div>
                            </div>
                            <p>
                                <span><img src={img} alt="task" /> Usuario creado el {formatDateToLongDate(dataProfile.date_joined)}</span>
                                <span>**Por el momento, las modificaciones al perfil no se encuentran disponibles.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="perfil-movil">
                <div className="container-main-movil">
                    <div className="card-profile-movil">
                        <div className="content-profile-movil">
                            <label>Configuración de perfil</label>
                            <span>Ayudanos a conocer más acerca de ti completando tus datos de perfil.</span>
                            <hr />
                            <div className="item-data-profile-movil">
                                <div className="label-input-data-profile-movil">
                                    <label>Nombre:</label>
                                    <input />
                                </div>
                            </div>
                            <div className="item-data-profile-movil">
                                <div className="label-input-data-profile-movil">
                                    <label>Apellido:</label>
                                    <input />
                                </div>
                            </div>
                            <div className="item-data-profile-movil">
                                <div className="label-input-data-profile-movil">
                                    <label>Usuario:</label>
                                    <input />
                                </div>
                            </div>
                            <div className="item-data-profile-movil">
                                <div className="label-input-data-profile-movil">
                                    <label>Correo:</label>
                                    <input />
                                </div>
                            </div>
                            <div className="item-data-profile-movil">
                                <div className="label-input-data-profile-movil">
                                    <label>Rol:</label>
                                    <input />
                                </div>
                            </div>
                            <div className="item-data-profile-movil">
                                <div className="label-input-data-profile-movil">
                                    <button>Editar perfil</button>
                                </div>
                            </div>
                        </div>
                        <div className="info-profile-movil">
                            <p><img src={img} alt="calendar" /> Usuario creado el 27 de Julio de 2022 a las 17:56  **Por el momento, las modificaciones al perfil no se encuentran disponibles.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { Perfil }